import { render } from "./userlists.vue?vue&type=template&id=61fd9a0f"
import script from "./userlists.vue?vue&type=script&lang=js"
export * from "./userlists.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__